import ZoomableImageModal from "./zoomableImageModal";

export default ZoomableImageModal;
